import { useState, useEffect } from "react";
import { Layout, Button } from "antd";
import { Outlet, Link } from "react-router-dom";
import "./MainLayout.css";
import AdminHeader from "./components/AdminHeader/AdminHeader";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import logo from "../Assets/svg/TPMlogo.svg";
import backtoWorkspaceRed from "../Assets/svg/backToWorkspaceRed.svg";
import FooterComponent from "./components/FooterComponent/FooterComponent";
import SidebarMenu from "./SidebarMenu";
import ProjectChatbot from "./components/ProjectChatbot/ProjectChatbot";
import {
  SidebarCollapseToggle,
  useSidebarCollapse,
} from "./components/SidebarCollapse/SidebarCollapse";

const { Header, Content, Sider, Footer } = Layout;

// Wide enough for a centred 18px icon and its hit area; `.sider--rail` in
// MainLayout.css matches it.
const RAIL_WIDTH = 76;

const ProjectLayout = ({
  notifications,
  setNotifications,
  unreadNotifications,
  setUnreadNotifications,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // `collapsed` above is the phone drawer; this is the desktop icons-only rail.
  const [iconsOnly, toggleIconsOnly] = useSidebarCollapse();
  const railMode = iconsOnly && !isSmallScreen;

  useEffect(() => {
    const onResize = () => setIsSmallScreen(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {isSmallScreen && collapsed ? null : (
        <Sider
          className={`sider${railMode ? " sider--rail" : ""}`}
          collapsed={railMode}
          collapsedWidth={RAIL_WIDTH}
          trigger={null}
          style={
            !collapsed ? { position: "fixed", right: "0", zIndex: 1001 } : {}
          }
        >
          <div className="siderHead">
            <a href="/dashboard/contracts" className="menuDesign">
              <img src={logo} className="siderLogo" alt="logo" />
            </a>
            {/* Off on phones: there the sider is already a full-width drawer, so
                a rail would just be a second way to hide the menu. */}
            {!isSmallScreen && (
              <SidebarCollapseToggle
                collapsed={railMode}
                onToggle={toggleIconsOnly}
              />
            )}
          </div>

          <SidebarMenu collapsed={railMode} />
        </Sider>
      )}
      {isSmallScreen && !collapsed && (
        <div className="sider-overlay" onClick={() => setCollapsed(true)} />
      )}

      <Layout className="site-layout">
        {!isGuestShare ? (
          <Header
            className="adminHeader d-flex align-items-center justify-content-between"
            style={{
              minHeight: "100px",
              padding: 0,
            }}
          >
            {collapsed ? (
              <AdminHeader
                notifications={notifications}
                setNotifications={setNotifications}
                unreadNotifications={unreadNotifications}
                setUnreadNotifications={setUnreadNotifications}
              />
            ) : (
              ""
            )}

            {isSmallScreen && (
              <Button
                type="text"
                icon={
                  collapsed ? (
                    <MenuOutlined
                      style={{
                        fontSize: 24,
                      }}
                    />
                  ) : (
                    <CloseOutlined
                      style={{
                        fontSize: 24,
                        color: "#fff",
                      }}
                    />
                  )
                }
                onClick={() => setCollapsed(!collapsed)}
                style={
                  !collapsed
                    ? {
                        position: "fixed",
                        top: 25,
                        right: 16,
                        zIndex: 9999,
                        background: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }
                    : {}
                }
              />
            )}
          </Header>
        ) : (
          <div className="mobile-back-projects">
            <Link
              to="/projects"
              style={{
                textDecoration: "none",
                color: "#aa1a5f",
                whiteSpace: "nowrap",
                overflow: "hidden",
                display: "block",
                textOverflow: "clip",
              }}
            >
              <img
                src={backtoWorkspaceRed}
                style={{
                  marginRight: "12px",
                }}
                alt="menu2"
              />
              Go Back
            </Link>
          </div>
        )}
        <Content style={{ margin: "0px", backgroundColor: "white" }}>
          <Outlet style={{ width: "100% !important" }} />
        </Content>
        <Footer>
          <FooterComponent />
        </Footer>
      </Layout>
      <ProjectChatbot />
    </Layout>
  );
};

export default ProjectLayout;
